import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useAppDispatch} from '../../hooks/redux';
import {appSlice} from '../../store/reducers/AppSlice';
import {statisticModelApi} from '../../api/StatisticModelsService';
import StatsModelForm from '../../components/stats/StatsModelForm';
import Loader from '../../components/ui/Loader';
import {IStatisticModelWrite} from '../../model/IStats';

const StatsModelFormPage = () => {
    const {id} = useParams();
    const isEdit = Boolean(id);
    const modelId = id ? Number(id) : undefined;
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {setTitle} = appSlice.actions;
    const {data: model, isLoading} = statisticModelApi.useFetchStatisticModelQuery(modelId as number, {skip: !isEdit});
    const [createModel, {isLoading: isCreating}] = statisticModelApi.useCreateStatisticModelMutation();
    const [updateModel, {isLoading: isUpdating}] = statisticModelApi.useUpdateStatisticModelMutation();

    useEffect(() => {
        dispatch(setTitle(isEdit ? 'Edit stats model' : 'New stats model'));
    });

    const handleSubmit = async (body: IStatisticModelWrite) => {
        if (isEdit && modelId) {
            const result = await updateModel({id: modelId, body});
            if ('data' in result) {
                navigate(`/stats/models/${modelId}`);
            }
            return;
        }
        const result = await createModel(body);
        if ('data' in result) {
            navigate(`/stats/models/${result.data.id}`);
        }
    };

    if (isEdit && isLoading) {
        return <div className="relative min-h-[8rem]"><Loader/></div>;
    }

    if (isEdit && !model) {
        return <p className="text-sm text-gray-500">Stats model not found.</p>;
    }

    return (
        <StatsModelForm
            initial={model}
            submitting={isCreating || isUpdating}
            submitLabel={isEdit ? 'Save' : 'Create'}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/stats/models')}
        />
    );
};

export default StatsModelFormPage;
